const organization = {
    require_membership: 'Пользователь должен быть участником организации, чтобы продолжить.',
    role_names_not_found: 'Обнаружены недопустимые имена ролей: {{names,list(type:conjunction)}}. Пожалуйста, сначала создайте эти роли, прежде чем продолжить.',
};
export default Object.freeze(organization);
